var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793.7 184.2",
    style: {
      enableBackground: "new 0 0 793.7 184.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#CC0033;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.4,76c0,12.6-8.3,21.1-20.2,21.1s-20.2-8.4-20.2-21.1s8.3-21.1,20.2-21.1S144.4,63.4,144.4,76  M164.1,113.4V38.6h-19.8v10.5h-0.3c-4.7-7.8-12.8-13-24.9-13c-19.6,0-36,14.3-36,39.9s16.4,39.9,36,39.9c12.2,0,20.2-5.2,24.9-13 h0.3v10.5H164.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.4,76c0,12.6-8.3,21.1-20.2,21.1c-12,0-20.2-8.4-20.2-21.1s8.3-21.1,20.2-21.1 C225.1,54.9,233.4,63.4,233.4,76 M253.1,113.4V0h-19.8v49.1H233c-4.7-7.8-12.8-13-24.9-13c-19.6,0-36,14.3-36,39.9 s16.4,39.9,36,39.9c12.2,0,20.2-5.2,24.9-13h0.3v10.5H253.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    className: "st0",
    width: 19.9,
    height: 19.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.6,
    y: 38.6,
    className: "st0",
    width: 19.9,
    height: 74.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.4,76c0,12.8-8.7,21.1-20.9,21.1s-21.1-8.3-21.1-21.1s8.9-21.1,21.1-21.1S355.4,63.2,355.4,76 M376,76 c0-23.5-17.7-39.9-41.5-39.9S293,52.5,293,76s17.7,39.9,41.5,39.9S376,99.5,376,76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.8,76c0,12.6-8.3,21.1-20.2,21.1c-12,0-20.2-8.4-20.2-21.1s8.3-21.1,20.2-21.1 C435.5,54.9,443.8,63.4,443.8,76 M464.5,76c0-25.6-16.4-39.9-36-39.9c-12.1,0-20.2,5.2-24.9,13h-0.3V38.6h-19.8v103.2h19.8v-38.8 h0.3c4.7,7.8,12.8,13,24.9,13C448.1,115.9,464.5,101.6,464.5,76"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 472.9,
    y: 0,
    className: "st0",
    width: 19.9,
    height: 113.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.4,76c0,12.6-8.3,21.1-20.2,21.1c-12,0-20.2-8.4-20.2-21.1s8.3-21.1,20.2-21.1 C554.2,54.9,562.4,63.4,562.4,76 M582.2,113.4V38.6h-19.8v10.5h-0.3c-4.7-7.8-12.8-13-24.9-13c-19.6,0-36,14.3-36,39.9 s16.4,39.9,36,39.9c12.1,0,20.2-5.2,24.9-13h0.3v10.5H582.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "647.8,38.6 628.4,83.9 609.4,38.6 586.1,38.6 618.5,106.5 602.1,141.7 622.6,141.7 668.7,38.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M719.9,67.3h-35.3c1.6-10.4,8.6-15.1,18.1-15.1C712.5,52.2,719.3,57.7,719.9,67.3 M740,80v-3.9 c0-25.6-13.6-40-36.3-40c-23.5,0-38.9,16.2-38.9,40s15.9,39.7,40.3,39.7c15.7,0,25.8-7.3,32.4-13.4l-10-14.4 c-4.2,4.2-11.7,10.2-22.4,10.2c-11.5,0-19.9-6.6-21.1-18.1H740z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M793.7,36.3h-0.8c-12.3,0-20.9,6.5-24.8,18.1h-0.3V38.6h-19.6v74.8h19.8V82.8c0-18.3,7.6-25.1,23.5-25.1h2.3 V36.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.6,70.9V0h-4.7H0v70.9v42.5h23.6V70.9z M75.6,35.4l-9.4,6.4V29L75.6,35.4z M59.1,46.7L52,51.5V19.3 l7.1,4.8V46.7z M44.9,56.4l-7.1,4.8V9.7l7.1,4.8V56.4z M85,35.4C85,15.9,69.2,0,49.6,0h-26l7.1,4.8V66l-7.1,4.8l33,42.5H85 L49.8,70.9h-0.2C69.2,70.9,85,55,85,35.4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "LIVE_x5F_TYPE_x5F__x28_60.75pt_x29_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,147.7v12h16.9v6H6.4v18.6H0.1v-42.5h24.6v6H6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.9,166.6h-3.8v17.7h-6.3v-42.5h14.5c7.5,0,13,4.7,13,12.5c0,6.4-3.9,11-9.9,12.1l12.9,17.9h-8L40.9,166.6z  M37.1,160.6h7.2c5.1,0,7.2-2.7,7.2-6.4c0-3.8-2.1-6.6-7.2-6.6h-7.2V160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.7,173.7H73.1l-4.1,10.6h-6.9l17.4-42.5h5.8l17.4,42.5h-6.9L91.7,173.7z M89.5,167.8l-7-18.2l-7,18.2H89.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.2,184.2h-6.6l-20.9-31.8h-0.1v31.8h-6.3v-42.5h6.6l20.9,31.8h0.1v-31.8h6.3V184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.6,163c0-13.2,9.3-22.2,22.8-22.2c6.4,0,11.1,1.9,15,4.7l-3.9,5.5c-2.5-1.8-6.3-3.8-11.4-3.8 c-8.9,0-15.6,6.1-15.6,15.7s6.7,15.7,15.6,15.7c5,0,8.9-1.9,11.4-3.8l3.9,5.5c-3.9,2.8-8.6,4.7-15,4.7 C156.9,185.2,147.6,176.2,147.6,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.8,178.3v6h-24.6v-42.5h24.3v6h-18v10.1h16.6v6h-16.6v14.6H215.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5bf2f09f7cfeea8d15ae1e44d4362d0e.svg";
export { ForwardRef as ReactComponent };